// Google Ads conversion labels - add new micro-conversions here as created
export const GOOGLE_ADS_CONVERSIONS = {
  // Main conversions (already exist and in use)
  contactFormSubmit: 'AW-764093659/BlDkCLqx5uobENvJrOwC',
  pricingFormSubmit: 'AW-764093659/qaawCM-J38oYENvJrOwC',
  demoBooked: 'AW-764093659/3OkzCLLa6coYENvJrOwC',

  // Micro-conversions (add as you create via MCP)
  contactFormView: 'AW-764093659/vE13CLCai-8bENvJrOwC',
  contactFormStart: 'AW-764093659/BnFiCNPB_O4bENvJrOwC',
  pricingFormView: 'AW-764093659/IofbCNbB_O4bENvJrOwC',
  pricingFormStart: 'AW-764093659/ZO2YCKqgi-8bENvJrOwC',
  pricingPageView: 'AW-764093659/upOvCOGei-8bENvJrOwC',
  ctaHero: 'AW-764093659/dut6COSei-8bENvJrOwC',
  ctaPricing: 'AW-764093659/ZfsBCK2gi-8bENvJrOwC',

  // Video demo milestones (created Feb 4, 2026)
  videoDemoPlay: 'AW-764093659/VdY5CN-VrfIbENvJrOwC', // $10 SECONDARY
  videoDemo5min: 'AW-764093659/7d48CL-WrfIbENvJrOwC', // $15 SECONDARY
  videoDemo15min: 'AW-764093659/Cl6uCP3VrfIbENvJrOwC', // $25 PRIMARY
  videoDemoComplete: 'AW-764093659/unEvCPnXrfIbENvJrOwC', // $40 PRIMARY

  // Gate form submissions (created Feb 24, 2026)
  pricingGateSubmit: 'AW-764093659/QUdaCOTLkv4bENvJrOwC', // $30
  demoGateSubmit: 'AW-764093659/JUPiCObOnv4bENvJrOwC', // $50
  leadMagnetSubmit: 'AW-764093659/RR5vCNbQnv4bENvJrOwC', // $20
} as const;

export type ConversionKey = keyof typeof GOOGLE_ADS_CONVERSIONS;

// Note: Window.gtag is already declared in hooks/useAnalytics.ts or elsewhere
// We use the existing global type

/**
 * Set enhanced conversion data (email, phone, name) for Google Ads.
 * Must be called BEFORE the conversion event on the same page.
 * Google hashes plaintext values automatically before transmission.
 */
export function setEnhancedConversionData(userData: {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
}): void {
  if (typeof window === 'undefined' || !window.gtag) return;

  const data: Record<string, unknown> = {};
  if (userData.email) data.email = userData.email.trim().toLowerCase();
  if (userData.phone) data.phone_number = userData.phone.trim();
  if (userData.firstName || userData.lastName) {
    data.address = {
      ...(userData.firstName && { first_name: userData.firstName.trim() }),
      ...(userData.lastName && { last_name: userData.lastName.trim() }),
    };
  }

  if (Object.keys(data).length > 0) {
    window.gtag('set', 'user_data', data);
  }
}

export function trackGoogleAdsConversion(
  sendTo: string,
  value: number,
  transactionId?: string
): void {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: sendTo,
      value,
      currency: 'USD',
      ...(transactionId && { transaction_id: transactionId }),
    });
  }
}

export function fireGoogleAdsConversion(
  key: ConversionKey,
  value: number,
  transactionId?: string
): void {
  trackGoogleAdsConversion(GOOGLE_ADS_CONVERSIONS[key], value, transactionId);
}
